// Shared helpers for serialized-item stock-in forms (JMB-238).
// Serials are typed or barcode-scanned one per line.

export function parseSerials(text) {
  if (!text) return [];
  return text
    .split(/\r?\n/)
    .map((s) => s.trim().toUpperCase())
    .filter((s) => s !== "");
}

// Returns an error string, or null when the list is valid for the quantity.
export function serialError(serials, quantity) {
  const qty = Number(quantity) || 0;
  if (serials.length !== qty) {
    return `Expected ${qty} serial number(s), got ${serials.length}.`;
  }
  const seen = new Set();
  const dupes = new Set();
  serials.forEach((s) => {
    if (seen.has(s)) dupes.add(s);
    seen.add(s);
  });
  if (dupes.size > 0) {
    return "Duplicate serial number(s): " + Array.from(dupes).join(", ");
  }
  return null;
}
